import { SensitiveDataResponse } from "apis/sensitiveData";
import { formatDate } from "utils/formatDate";

export const SensitiveDataLastUpdatedCell = ({
  record,
}: {
  record: SensitiveDataResponse;
}) => {
  const { updated_at, updated_by } = record;

  if (!updated_at) return <span className="t-text-body-sm">-</span>;

  return (
    <div className="t-flex t-flex-col t-gap-0.5">
      <span className="t-text-body t-text-text-60">
        {formatDate(updated_at)}
      </span>
      {Boolean(updated_by) && (
        <span className="t-text-body-sm t-font-light t-text-text-30">
          Added by {updated_by}
        </span>
      )}
    </div>
  );
};
